import { ErrorIcon, LogOutIcon } from "assets";
import { CancelButton, SmallScreenModel, SubmitButton, Error } from "components";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { stateStatusType } from "../store/actionType";
import { authLogout } from "../store/action";
import { ResetAuth } from "modules/auth/login/store/action";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Logout: React.FC<Props> = ({ onAuthLogout, logoutState, onResetAuth }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleLogout = async () => {
    try {
      setLoading(true);
      setRedirect(true);
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("actions");
      sessionStorage.removeItem("superAdmin");
      await onAuthLogout();
      setSubmitted(true)
    } catch (err) {
      console.error("Logout error:", err);
      setError("Unexpected logout failure.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    setLoading(true);
    setRedirect(true);
    if (logoutState.status === stateStatusType.SUCCESS && submitted) {
      onResetAuth(); // optional chaining in case it's not passed
      setIsModalOpen(false);
      navigate("/login");
    } else if (logoutState.status === stateStatusType.FAILED) {
      setError(logoutState.error);
    }
  }, [logoutState, redirect, submitted]);

  return (
    <>
      <button
        className="w-full flex items-center text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        onClick={openModal}
        type="button"
      >
        <LogOutIcon />
        Sign Out
      </button>
      <SmallScreenModel showModal={isModalOpen} setShowModal={setIsModalOpen}>
        <div className="text-center">
          <ErrorIcon className="mx-auto mb-4 text-red-500 w-12 h-12" />
          <h3 className="mb-5 text-lg font-normal text-black">
            Are you sure you want to sign out?
          </h3>
          <div className="flex justify-center space-x-4">
            <SubmitButton onClick={() => handleLogout()}>
              Log Out
            </SubmitButton>
            <CancelButton onClick={closeModal} />
          </div>
        </div>
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onAuthLogout: () => dispatch(authLogout()),
  onResetAuth: () => dispatch(ResetAuth())
});

const mapStateToProps = (state: any) => ({
  logoutState: state.logout.logoutState,
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);